export default __webpack_public_path__ + "static/media/Legion Fighters Ring.99963f19.jpg";